import React from 'react';

const ACHIEVEMENTS = [
  { id: 'ach-001', emoji: '🏆', title: 'Dog of the Day', desc: 'Selected as Dog of the Day on June 1, 2026', date: 'Jun 1, 2026', rarity: 'Legendary', rarityColor: 'text-amber-600 bg-amber-50 border-amber-200' },
  { id: 'ach-002', emoji: '❤️', title: 'Beloved Companion', desc: 'Received 1,000+ paws from the community', date: 'Mar 14, 2026', rarity: 'Epic', rarityColor: 'text-violet-600 bg-violet-50 border-violet-200' },
  { id: 'ach-003', emoji: '⭐', title: 'Birthday Star', desc: 'Profile celebrated on 5 consecutive birthdays', date: 'May 3, 2026', rarity: 'Rare', rarityColor: 'text-blue-600 bg-blue-50 border-blue-200' },
  { id: 'ach-004', emoji: '🌟', title: 'Community Favorite', desc: 'Featured in the Weekly Digest 3 times', date: 'Apr 7, 2026', rarity: 'Rare', rarityColor: 'text-blue-600 bg-blue-50 border-blue-200' },
  { id: 'ach-005', emoji: '📸', title: 'Memory Keeper', desc: 'Added 25+ memories to the timeline', date: 'Feb 20, 2026', rarity: 'Uncommon', rarityColor: 'text-green-600 bg-green-50 border-green-200' },
  { id: 'ach-006', emoji: '🏅', title: 'Founding Dog', desc: 'One of DoggyYears\' original 100 founding profiles', date: 'Jan 1, 2026', rarity: 'Exclusive', rarityColor: 'text-amber-700 bg-amber-50 border-amber-300' },
  { id: 'ach-007', emoji: '🎂', title: 'Birthday Royalty', desc: 'Birthday celebrated by 200+ community members', date: 'May 3, 2025', rarity: 'Epic', rarityColor: 'text-violet-600 bg-violet-50 border-violet-200' },
  { id: 'ach-008', emoji: '🤝', title: 'Social Butterfly', desc: 'Followed by 500+ members', date: 'Nov 11, 2025', rarity: 'Uncommon', rarityColor: 'text-green-600 bg-green-50 border-green-200' },
];

export default function DogAchievements() {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-700 text-foreground">Achievements</h2>
        <span className="text-sm text-muted-foreground">18 of 42 earned</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {ACHIEVEMENTS?.map((a) => (
          <div key={a?.id} className="bg-card border border-border rounded-2xl p-5 shadow-card card-hover flex flex-col gap-3">
            <div className="text-4xl">{a?.emoji}</div>
            <div>
              <p className="font-700 text-sm text-foreground mb-0.5">{a?.title}</p>
              <p className="text-xs text-muted-foreground leading-relaxed">{a?.desc}</p>
            </div>
            <div className="flex items-center justify-between mt-auto">
              <span className={`text-xs font-700 px-2 py-0.5 rounded-full border ${a?.rarityColor}`}>{a?.rarity}</span>
              <span className="text-xs text-muted-foreground">{a?.date}</span>
            </div>
          </div>
        ))}
        {/* Locked achievements */}
        {Array.from({ length: 4 })?.map((_, i) => (
          <div key={`locked-${i + 1}`} className="bg-muted border border-dashed border-border rounded-2xl p-5 flex flex-col gap-3 opacity-50">
            <div className="text-4xl grayscale">🔒</div>
            <div>
              <p className="font-700 text-sm text-foreground mb-0.5">Locked Achievement</p>
              <p className="text-xs text-muted-foreground">Keep adding memories to unlock</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}